<ng-container [appPreloader]="[endpoints.BASIQ_ACCOUNTS_GET, endpoints.BASIQ_DELETE, endpoints.BASIQ_TOKEN_GET]" [preloaderType]="preloaderTypes.OVERLAY"></ng-container>

<!-- Desktop view -->
@if (!viewPortService.isMobile) {
  <div mat-dialog-content class="bank-connections-dialog-content">
    @if (form) {
      <form [formGroup]="form" (ngSubmit)="submit()" class="transparent" appFormErrorScroll>
        <div class="row">
          <div class="col-6">
            <app-datepicker label="Import transactions from" formControlName="migrateFrom"></app-datepicker>
          </div>
          <div class="col-6">
            <app-datepicker label="Import transactions to" [startOfDay]="true" formControlName="migrateTo"></app-datepicker>
          </div>
          <!-- @TODO Front: create component or directive to handle formGroup errors -->
          @if (form.submitted && form.hasError('arrayControlsDisabled')) {
            <div class="col-12">
              <div class="form-group-error">{{nothingSelectedErrorMessage}}</div>
            </div>
          }
        </div>
        <div class="bank-accounts-container">
          @for (bankAccountForm of form.get('bankAccounts').controls; track bankAccountForm) {
            <app-bank-account-import-form
              [form]="bankAccountForm">
            </app-bank-account-import-form>
          }
          @if (savedAccounts.length) {
            <div class="fs-big c-secondary fw-bold mv-10">Imported bank accounts</div>
            <app-bank-accounts-import [bankAccounts]="savedAccounts"></app-bank-accounts-import>
          }
          @if (disconnectedBankAccounts.length) {
            <div class="fs-big c-secondary fw-bold mv-10">Inactive bank accounts</div>
            <div class="c-gray">
              Inactive banks cannot receive live bank feeds. To enable live bank transactions, please click the 'Manage Accounts' button below, disconnect this bank, and then reconnect it. Please ensure you select all bank accounts you wish to share. Any missing transactions will be updated overnight.
            </div>
            <app-bank-accounts-import [bankAccounts]="disconnectedBankAccounts"></app-bank-accounts-import>
          }
        </div>
      </form>
    }
  </div>
}

<!-- Mobile view -->
@if (viewPortService.isMobile) {
  <div mat-dialog-content>
    <!-- Bank accounts allowed to import -->
    @if (bankAccounts.length) {
      <div class="text-center c-secondary fs-big mb-15">
        Click on the account bank tabs to import them into active tanks.
      </div>
      @for (bankAccount of bankAccounts; track bankAccount) {
        <app-bank-account-preview-card
          [bankAccount]="bankAccount"
          [isActive]="true"
          class="mb-10"
          (click)="openBankAccountImportFormDialog(bankAccount)">
        </app-bank-account-preview-card>
      }
    }
    <!-- Imported bank accounts -->
    @if (savedAccounts.length) {
      <div class="text-center c-secondary fs-big mb-15">Imported bank accounts</div>
      @for (bankAccount of savedAccounts; track bankAccount) {
        <app-bank-account-preview-card class="mb-10" [bankAccount]="bankAccount"></app-bank-account-preview-card>
      }
    }
  </div>
}

<div mat-dialog-actions>
  <div class="row gx-3 align-h-right">
    <div class="col-6 col-sm-auto align-v-center">
      <button class="btn link c-primary"
        [appConfirm]="messages.CONFIRM_MANAGE"
        (accepted)="reconnect(connection)">
        Manage accounts
      </button>
    </div>

    <div class="col-6 col-sm-auto">
      <button (click)="back.emit()" class="btn basic block" type="button">Back</button>
    </div>

    <!-- Sumbit is not allowed for mobile because we are using separated dialog component for bank account import -->
    @if (!viewPortService.isMobile) {
      <div class="col-6 col-sm-auto">
        <button class="btn primary w-100" (click)="formRef.ngSubmit.emit()" [disabled]="!form">Submit</button>
      </div>
    }
  </div>
</div>
